import { useQuery } from '@tanstack/react-query';

import { useRequest, getIccSetupTokenKey } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  IccSetupTokenData,
  UseIccSetupTokenParams,
  IccSetupTokenQueryKey,
} from './types';

export const useIccSetupToken: QueryFunction<
  IccSetupTokenData,
  [UseIccSetupTokenParams],
  IccSetupTokenQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getIccSetupTokenKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(
        `/managed_integrations/${params.managedIntegrationUuid}/icc_setup_token`,
        {
          init: {
            signal,
          },
        },
      ),
  });
};
